import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
    state: () => ({
        userData: JSON.parse(sessionStorage.getItem('userData')) || null,
    }),

    actions: {
        setUserData(data) {
            // Если не передан expiresAt — добавим 1 час по умолчанию
            const withExpiry = {
                ...data,
                expiresAt: data.expiresAt || Date.now() + 60 * 60 * 1000, // 1 час
            }

            this.userData = withExpiry
            sessionStorage.setItem('userData', JSON.stringify(withExpiry))
        },

        clearUserData() {
            this.userData = null
            sessionStorage.removeItem('userData')
        },
    },

    getters: {
        isAuthenticated: (state) => !!state.userData,
        branch: (state) => state.userData?.branch,
        context: (state) => state.userData?.employeeContextResponse,
        isExpired: (state) =>
            state.userData?.expiresAt && Date.now() > state.userData.expiresAt,
    },
})
